'use strict';

var React = require('react'),
    TransitionEventsMixin = require('../mixins/TransitionEventsMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin');

require('./legacy/Stamp.less');
require('./Fade.less');

var Fade = React.createClass({
  mixins: [ClassNameMixin, TransitionEventsMixin, PureRenderMixin],

  propTypes: {
    color: React.PropTypes.string.isRequired,
    opacity: React.PropTypes.number.isRequired,
    isActive: React.PropTypes.bool.isRequired,
    isVisible: React.PropTypes.bool.isRequired,
    isLightboxVisible: React.PropTypes.bool.isRequired,
    isTop: React.PropTypes.bool
  },

  className: 'stamp-Fade',

  getCSSModifiers: function () {
    return [this.props.isTop && 'top'];
  },

  getInitialState: function () {
    return {
      animateOpacity: false
    };
  },

  componentWillReceiveProps: function (newProps) {
    var lightboxChanged = newProps.isLightboxVisible !== this.props.isLightboxVisible,
        activeChanged = newProps.isActive !== this.props.isActive,
        visibleChanged = newProps.isVisible !== this.props.isVisible,
        dOpacity = Math.abs(newProps.opacity - this.props.opacity);

    if (lightboxChanged || activeChanged && !visibleChanged && dOpacity > 0) {
      this.setState({
        animateOpacity: true
      });
    }
  },

  handleTransitionEnd: function () {
    this.setState({
      animateOpacity: false
    });
  },

  render: function () {
    var opacity = this.getOpacity(),
        style;

    style = {
      pointerEvents: opacity < 1 ? 'none': '',
      opacity: opacity,
      backgroundColor: '#' + this.props.color
    };

    return (
      <div className={this.getClassName()}
           data-animate={this.state.animateOpacity}
           style={style} />
    );
  },

  getOpacity: function () {
    if (this.props.isLightboxVisible) {
      return 1;
    }

    // Chrome gets stuck at 0 opacity sometimes
    return this.props.opacity || 0.00001;
  }
});

module.exports = Fade;


/** WEBPACK FOOTER **
 ** ./stamp/Fade.jsx
 **/